import { combineReducers } from '@reduxjs/toolkit';

import teamTasksSlice from './teamTasks/teamTasksSlice';
import userTasksSlice from './userTasks/userTasksSlice';
import actionsSlice from './actions/actionsSlice';
import exportSlice from './export/exportSlice';
import projectTasksListSlice from './projectTasksListSlice';
import bulkActionsSlice from './bulkActions';
import taskMetricsSlice from './tasksMetrics/taskMetricsSlice';

export default combineReducers({
  value: projectTasksListSlice,
  teamTasks: teamTasksSlice,
  userTasks: userTasksSlice,
  actions: actionsSlice,
  export: exportSlice,
  bulkActions: bulkActionsSlice,
  tasksMetrics: taskMetricsSlice,
});
